import { WhiteLabelIntegration } from 'shared/interfaces/SmartAssistant';

export interface WhiteLabelSubDomain {
  prefix: string;
  verified: boolean;
  record: DNSRecord;
}

export interface WhiteLabelDomain {
  _id: string;
  organisation: string;
  appId: string;
  value: string;
  status: WhiteLabelDomainStatus;
  certificateVerificationDNSRecord?: DNSRecord;
  subdomains: WhiteLabelSubDomain[];
  statusMessage?: string;
  lastRefreshedAt?: number;
}

export interface DNSRecord {
  type: DNSRecordType;
  host: string;
  value: string;
}

export enum WhiteLabelDomainStatus {
  CREATING = 'CREATING',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  PENDING_DEPLOYMENT = 'PENDING_DEPLOYMENT',
  AVAILABLE = 'AVAILABLE',
  UPDATING = 'UPDATING',
  FAILED = 'FAILED'
}

export enum DNSRecordType {
  ANAME = 'ANAME',
  CNAME = 'CNAME'
}

export interface AddWhiteLabelSubDomainDto {
  domainId: string;
  prefix: string;
}

export interface DeleteWhiteLabelSubDomainDto {
  domainId: string;
  prefix: string;
}

export interface AddWhiteLabelDomainDto {
  value: string;
}

export interface UpdateWhiteLabelDomainAndSmartAssistantAssociationDto {
  smartAssistantId: string;
  whiteLabelIntegration?: WhiteLabelIntegration;
}
